/* tslint:disable */
/* eslint-disable */
/**
 * Neptune Leaderboard REST API
 * Public REST API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: contact@neptune.ml
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GridModeConfigDTO
 */
export interface GridModeConfigDTO {
    /**
     * 
     * @type {string}
     * @memberof GridModeConfigDTO
     */
    columnsCount: string;
}

/**
 * Check if a given object implements the GridModeConfigDTO interface.
 */
export function instanceOfGridModeConfigDTO(value: object): value is GridModeConfigDTO {
    if (!('columnsCount' in value) || value['columnsCount'] === undefined) return false;
    return true;
}

export function GridModeConfigDTOFromJSON(json: any): GridModeConfigDTO {
    return GridModeConfigDTOFromJSONTyped(json, false);
}

export function GridModeConfigDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): GridModeConfigDTO {
    if (json == null) {
        return json;
    }
    return {
        
        'columnsCount': json['columnsCount'],
    };
}

export function GridModeConfigDTOToJSON(value?: GridModeConfigDTO | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'columnsCount': value['columnsCount'],
    };
}

